// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"23f72fbb","630":"72332e2d","935":"c59aa6fa"}[chunkId] + ".js";
};